
























































































































import Vue from 'vue';
import CompanyInfo from '@/components/CompanyInfo.vue';

export default Vue.extend({
    components: {
        CompanyInfo,
    },
});
